export const Capitalize = (string) => {
    if (typeof string !== 'string' || string.length === 0) {
        return string; // Return the original string if it's not a valid string
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function maskExceptLast4(value) {
    const str = String(value); // ensure it's a string
    const visible = str.slice(-4);
    const masked = '*'.repeat(str.length - 4);
    return masked + visible;
}

export const limitLength = (item) => {
    return `${item?.slice(0, 10)}......${item?.slice(-10)}`
}